<div class="choice-controls-wrapper primary-bg-color"  [ngClass]="{'position-fixed': hasFixedPosition}" #wrapper>
  <div class="choice-controls">
    <div class="btn-controls">
      <div class='choice-actions-wrapper'>
        <div class="custom-left-container" *ngIf="!(viewPort$ | async)?.isMobile">
          <ng-content select=".custom-left-content"></ng-content>
        </div>

        <div class="wrapping-unit">
          <div class="button-wrapper" *ngIf="!(viewPort$ | async)?.isMobile">
            <button class='btn primary-bg-color action-text-color primary-bg-border-color shadowed text-uppercase action-btn fw-600 back-btn font-secondary previous-step-btn text-uppercase'
                    *ngIf='hasBackBtn'
                    (click)='onBackBtnClick()'>
              <span class="arrow-left"></span>{{'component.step_controls.back' | translate}}
            </button>
          </div>

          <div class="button-wrapper" *ngIf='hasForwardBtn'>
            <button class='btn selection-bg-color selection-inverse-text-color selection-border-color shadowed text-uppercase action-btn fw-600 font-secondary next-step-btn'
                    (click)='onForwardBtnClick()'>
              <span class="choice-text">{{'component.step_controls.next' | translate}}: {{forwardBtnItemLabel}}</span>
            </button>
          </div>

          <div *ngIf='hasForwardBtn && !isHalfAndHalf && (hasSubmitBtn || (isItemValid && !(viewPort$ | async)?.isMobile))'
               class='button-wrapper step-controls-or-separator font-secondary fw-600 padded-left-10 padded-right-10 text-uppercase'>
            <span>{{'component.step_controls.or' | translate}}</span>
          </div>

          <ng-container *ngIf='!isHalfAndHalf && (hasSubmitBtn || isItemValid)'>
            <div class='button-wrapper add-update-order-btn'>
              <button
                ftsAsyncButton
                [subscription]='submitLoadingSubscription'
                class='btn action-bg-color action-inverse-text-color shadowed action-btn font-secondary submit-btn text-uppercase margin-right-10'
                (click)="onSubmitBtnClick()">
                {{submitBtnLabel}}
              </button>
            </div>
          </ng-container>
        </div>

      </div>
    </div>
  </div>
</div>
